/* eslint react/no-string-refs: "off" */

import React from 'react';

export class Confirmation extends React.Component {
  render() {
    return (
      <div className='dialog dialog--modal NoticesConfirmationDialog'>
        <div className='dialog__header'>
          <span className='dialog__title'>{this.props.dialog.state.title}</span>
        </div>
        {this.props.dialog.state.content && (
          <div className='dialog__body'>
            <p className='dialog__body__text'>
              {this.props.dialog.state.content}
            </p>
          </div>
        )}
        <div className='dialog__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.close();
            }}
          >
            閉じる
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationDialog.jsx